const state = {
  messageStatuses: []
}

const getters = {}

const mutations = {
  setMessageStatuses (state, data) {
    state.messageStatuses = data
  }
}

const actions = {
  setMessageStatuses (context, data) {
    context.commit('setMessageStatuses', data)

    const messagesById = new Map()
    for (const message of context.rootState.message.messages) {
      if (!messagesById.has(message.MessageID)) {
        messagesById.set(message.MessageID, message)
      }
    }

    for (const item of data) { // burası mesajların içerisine statusu koymak için
      var message = messagesById.get(item.MessageID)

      if (message !== undefined) {
        message.Status = item.Status
        // this.$set(message,'Status',item.Status)
      }
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
